<template>
    <div class="termsOfUse container">
        <h1 class="red-text center">CEDEX ADMINISTRATION FACILITY</h1>
        <h2 class="center">COA SYNTAX EDITOR – CEDEX SYNTAX</h2>

        <p class="center">
            <br />
            The Terms of Use for the “Industry User Agreement” are made and agreed by:<br />
            <br />
            <span class="bold">Container Owners Association Ltd.</span><br />
            Suite 3, Charter House, 26 Claremont Road, Surbiton, KT6 4QZ, United Kingdom.<br />
            <br />
            and<br />
            <br />
            <span class="bold">{{currentFullName}}</span><br />
            <br />
            <span class="small-font">Together the parties (“Parties”).</span>
        </p>
        <h2>1. General Joint Collaboration Principles</h2>
        <p>
            The Container Owners Association Ltd. will provide <span class="bold">{{currentFullName}}</span> and individuals as well as legal entities, which work
            for <span class="bold">{{currentCompany}}</span> and/or are entrusted by <span class="bold">{{currentCompany}}</span>, collectively referred to as “Industry Users”
            or “Users” hereinafter, with access to the COA Software Suite Content
        </p>
        <p>
            <ul>
                <li>the COA SYNTAX EDITOR</li>
                <ul>
                    <li>
                        once they have completed the registration process and accepted the Terms of Use for Industry Users, as
                        stated in this document, provided online during the registration process;
                    </li>
                    <li>
                        the CEDEX SYNTAX (published knowledge of industry experts and the COA Administration Committee)
                    </li>
                </ul>
                <li>API interface available</li>
                <li>CSV download available, as flat file, separated by container categories (e.g. Dry 20, Dry 40, etc.)</li>
            </ul>
        </p>
        <p>
            The Container Owners Association Ltd., reserves the right to use, administrate and exploit the CEDEX SYNTAX and
            the COA SYNTAX EDITOR, at the discretion of the "COA Administration Committee", which in particular includes
            the administration and further development of the CEDEX SYNTAX itself and related functionalities.
        </p>
        <p>
            The use of the COA Software Suite Content is subject to the terms and conditions contained in this document. The
            Industry Users agree that:
        </p>
        <p>
            <ul>
                <li>
                    all materials provided by the Container Owners Association Ltd., including but not limited
                    to information, documents, products, logos, graphics, sounds, GUI, software, and services including the
                    Software and Services, are provided either by the Container Owners Association Ltd. or by their respective
                    third-party authors, developers and vendors ("Third Party Providers"). Both the Container Owners Association
                    Ltd. and Third Party Providers are together referred to as “COA” hereinafter. Any and all related intellectual
                    property rights are, and remain, solely owned by COA. Elements of the COA Contract Software and Services
                    are protected by trade dress and other laws and may not be copied or imitated in whole or in part.
                </li>
                <li>
                    Industry Users will not use any content or materials on the COA Software Suite Content for any purpose which
                    is not expressly permitted in these Terms of Use for Industry Users.
                </li>
            </ul>
        </p>
        <p>
            By posting or providing any Content to COA or COA’s representative(s), Industry Users hereby grant the right to COA,
            in line with the EU data privacy laws, to adapt, translate, create derivative works, and otherwise use any or all of such
            Content for purposes which may be beneficial to the operation of the COA CEDEX EDITOR or related Services and
            thereby for the user.
        </p>
        <p>
            Interest from COA members and non-members in the COA Software Suite Content should be forwarded to the COA.
            Industry Users are not empowered to conclude agreements in any matters or otherwise legally bind or oblige the COA
            without the express written consent of the COA.
        </p>
        <p>
            Nothing in these Terms of Use for Industry Users is intended to create an agency or any other type of relationship
            between COA, Industry Users or any COA member, non-member or other party.
        </p>
        <p>
            The overarching principle is that the Parties agree to collaborate and act in good faith to the extent commercially
            reasonable in their absolute and sole discretion.
        </p>
        <h2>2. No transfer / Establishment of Rights / IP</h2>
        <p>
            COA is, and remains, at all times, the sole and exclusive owner or licensee of all the rights and interests in the COA
            Software Suite Content. All title, ownership and intellectual property rights in the COA Software Suite Content shall
            remain the exclusive property of COA or their affiliates or licensors, as the case may be.
        </p>
        <h2>3. Warranty /Guaranty /Liability and Indemnification</h2>
        <p>
            COA provides the products and services to the best of its knowledge "as is", "as available" and “with all faults” and the
            COA expressly disclaims, to the extent legally permissible, any and all representations and warranties, express or
            implied. All such warranties, representations, conditions, and undertakings are hereby, to the extent legally
            permissible, excluded.
        </p>
        <p>
            COA assumes, to the extent legally permissible, no liability for the COA Software Suite Content including but not
            limited to being free of third-party rights.
        </p>
        <p>
            COA makes no representations or warranties with regard to the validity, accuracy, reliability, quality, stability,
            completeness or correctness of any information provided on or through the COA Software Suite Content. Industry
            Users hereby waive any legal liability for any defects.
        </p>
        <p>
            Industry Users hereby agree to indemnify and hold harmless COA and its affiliates, from any and all losses, claims
            and liabilities (including legal costs on a full indemnity basis) which may arise from such user's use of the COA
            Software Suite Content (including but not limited to the display of such user's information on the Contract Software
            and Services) or from any breach by such user of any of the terms and conditions of these Terms of Use for Industry
            Users.
        </p>
        <p>
            Industry Users hereby further agree to indemnify and hold harmless COA and its affiliates, from any and all losses,
            damages, claims and liabilities (including legal costs on a full indemnity basis) which may arise, directly or indirectly,
            as a result of claims asserted by third party providers, claimants or other third parties relating to the User Content
            offered or displayed on the COA Software Suite.
        </p>
        <p>
            To the extent legally permissible, COA shall not be liable for any special, direct, indirect, punitive, incidental or
            consequential damages or any damages whatsoever (including but not limited to damages for loss of profits or
            savings, business interruption, loss of information), whether in contract, negligence, tort, equity or otherwise or any
            other damages. COA’s aggregate liability for any and all claims in connection with these Terms of Use for Industry
            Users, whether under contract, tort or otherwise, shall be limited to GBP 5,000.
        </p>
        <p>
            Under no circumstances shall COA be held liable for any delay or failure or disruption of the content, products or
            services provided resulting directly or indirectly from acts of nature, forces or causes beyond our reasonable control,
            including without limitation, Internet failures, computer, telecommunications or any other equipment failures, electrical
            power failures, strikes, labor disputes, riots, insurrections, civil disturbances, shortages of labor or materials,
            pandemics and epidemics, fires, flood, storms, explosions, acts of God, war, governmental actions, orders of domestic
            or foreign courts or tribunals or non- performance of third parties.
        </p>
        <p>
            Each User is solely responsible for maintaining the confidentiality of User`s access information, i.e. account ID's and
            passwords and is responsible for all activities that occur under User`s account.
        </p>
        <h2>4. Governing law and jurisdiction</h2>
        <p>
            Legal relationships between the parties in connection with these Terms of Use for Industry Users shall be governed
            by, and be construed in accordance with, the Laws of the United Kingdom, without regard to the United Nations
            Convention on Contracts for the International Sale of Goods (CISG).
        </p>
        <p>
            Exclusive place of jurisdiction is London, UK.
        </p>
        <h2>5. Miscellaneous</h2>
        <p>
            Unless explicitly set forth otherwise in these Terms of Use for Industry Users, any provision of these Terms of Use for
            Industry Users (including this Section) may be amended or waived only if such amendment or waiver is made by
            written instrument executed by the Parties and explicitly refers to these Terms of Use for Industry Users.
        </p>
        <p>
            Should any provision of these Terms of Use for Industry Users, or any provision incorporated into these Terms of Use
            for Industry Users, in the future, be or become invalid or unenforceable, the validity or enforceability of the other
            provisions shall not be affected thereby. The invalid or unenforceable provision shall be deemed to be substituted by a
            suitable and equitable provision which, to the extent permitted under applicable law, comes as close as possible to the
            intent and purpose of the invalid or unenforceable provision.<br />
            The same shall apply<br />
            (i) if the Parties have, unintentionally, failed to address a certain matter in these Terms of Use for Industry Users; in
            this case a suitable and equitable provision shall be deemed to have been agreed upon which comes as close as
            possible to what the Parties, in the light of the intent and purpose of these Terms of Use for Industry Users, would
            have agreed upon if they had considered the matter; or<br />
            (ii) if any provision of these Terms of Use for Industry Users are invalid because of the scope of any time period or
            performance stipulated herein; in this case a legally permissible time period or performance shall be deemed to have
            been agreed which comes as close as possible to the stipulated time period or performance.
        </p>
    </div>
</template>

<script>
export default {
    name: "TermsOfUse",
    props: {
        fullName: String,
        company:  String
    },
    data() {
        return {
            loadedFullName: this.fullName,
            loadedCompany:  this.company,
        }
    },
    computed: {
        currentFullName() {return this.loadedFullName},
        currentCompany()  {return this.loadedCompany},
    },
    mounted: function() {
        this.$auth
            .load()
            .then(() => {
                if (this.$auth.check()) {
                    let userData = JSON.parse(this.$auth.remember());
                    let user = this.$auth.user(userData);
                    this.loadedFullName = user.name;
                    this.loadedCompany  = user.company;
                }
            });
    }
}
</script>

<style scoped>
    .termsOfUse {
        text-align: left;
        user-select: text;
        padding: 32px;
        overflow: auto;
    }
    .termsOfUse h1 {
        text-align: center;
    }
</style>